module.exports = __webpack_public_path__ + "static/media/grey-strips.33d04a00.svg";